import React from "react";
import { newSinceLabel, marketLine } from "../../helpers/widgetLastVisit";
import "./WidgetSinceLastVisit.scss";

const WidgetSinceLastVisit = ({
  newSince,
  totalCount,
  marketName,
  onOpenNew,
  onOpenFeed,
}) => {
  if (newSince) {
    const label = newSinceLabel(newSince);
    return (
      <div className="wslv wslv--new" role="status" aria-live="polite">
        <span className="wslv-text">{label}</span>
        <button
          type="button"
          className="wslv-link"
          onClick={onOpenNew}
          aria-label={`View ${label}`}
        >
          View
        </button>
      </div>
    );
  }

  return (
    <div className="wslv">
      <span className="wslv-text wslv-text--market">
        {marketLine(totalCount, marketName)}
      </span>
      <button type="button" className="wslv-pill" onClick={onOpenFeed}>
        Open the feed
      </button>
    </div>
  );
};

export const WidgetSeenDivider = () => (
  <div className="wslv-divider" role="separator" aria-label="Seen before">
    <span>Seen before</span>
  </div>
);

export default WidgetSinceLastVisit;
